export const USER_GET_CACHE_TIME = 24 * 60 * 60 * 1000;
export const USER_GET_STALE_TIME = 24 * 60 * 60 * 1000;
export const ORGANIZATION_GET_CACHE_TIME = 24 * 60 * 60 * 1000;
export const ORGANIZATION_GET_STALE_TIME = 24 * 60 * 60 * 1000;
export const LAUNCH_DARKLY_CACHE_TIME = 24 * 60 * 60 * 1000;
export const LAUNCH_DARKLY_STALE_TIME = 24 * 60 * 60 * 1000;
export const AVAILABLE_MERGE_FIELDS_CACHE_TIME = 24 * 60 * 60 * 1000;
export const AVAILABLE_MERGE_FIELDS_STALE_TIME = 24 * 60 * 60 * 1000;
export const SFDC_META_CACHE_TIME = 24 * 60 * 60 * 1000;
export const SFDC_META_STALE_TIME = 24 * 60 * 60 * 1000;
export const AVAILABLE_PICKLIST_VALUES_CACHE_TIME = 24 * 60 * 60 * 1000;
export const AVAILABLE_PICKLIST_VALUES_STALE_TIME = 24 * 60 * 60 * 1000;
